import { Curl } from "components/Jarvis"


export const postMerchantInfo = (data) => {
    return Curl.post(
        `/gateway/resources/merchant/update`,data
    ).then((res) => {
        return res;
    })
}

export const getMerchantInfo = (id) => {
    return Curl.get(
        `/gateway/resources/merchants/${id}`
    ).then((res) => {
        return res;
    })
}
export const getMerchantUpdateLog=()=>{
    return Curl.get(`/gateway/resources/merchants/updatelog`).then((res) => {
        return res;
    })
}
